export default __webpack_public_path__ + "static/media/bannerImage1.0dfa6815.jpg";